<p-card *ngIf="template">
  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center p-3">
      <h3>Preview de Plantilla</h3>
      <p-selectButton 
        [options]="[
          {label: 'Email', value: 'email'},
          {label: 'SMS', value: 'sms'},
          {label: 'WhatsApp', value: 'whatsapp'},
          {label: 'Llamada', value: 'call'}
        ]" 
        [(ngModel)]="channel"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>
    </div>
  </ng-template>
  
  <div class="preview-content" [ngSwitch]="channel">
    <div *ngSwitchCase="'email'" class="email-preview">
      <h4>{{ replaceVariables((template.emailTemplate && template.emailTemplate.subject) || '') }}</h4>
      <div class="email-body" [innerHTML]="previewContent"></div>
    </div>
    
    <div *ngSwitchCase="'sms'" class="sms-preview">
      <div class="sms-bubble">{{ previewContent }}</div>
    </div>
    
    <div *ngSwitchCase="'whatsapp'" class="whatsapp-preview">
      <div class="whatsapp-bubble">{{ previewContent }}</div>
    </div>
    
    <div *ngSwitchCase="'call'" class="call-preview">
      <div class="call-script">
        <pre>{{ previewContent }}</pre>
      </div>
    </div>
  </div>
</p-card>
